import { createSelector } from '@reduxjs/toolkit';
import {
    EMAIL_LIST_CACHE_TIME,
    EmailListSlice,
    emptyEmailList,
} from '@/redux/modules/account/notifications/emailList/emailList.types';
import { GlobalState } from '@/redux/store';

const sliceSelector = ({ emailList }: GlobalState): EmailListSlice => emailList;
const codeSelector = (_: GlobalState, code: string) => code;

export const getEmailLists = createSelector(
    sliceSelector,
    (state) =>
        (state.lists &&
            state.lists.toSorted((a, b) => a.type.localeCompare(b.type)).toSorted((a, b) => a.sequence - b.sequence)) ||
        []
);

export const getEmailList = createSelector(
    [sliceSelector, codeSelector],
    (state, code) => state.lists.find((x) => x.code === code) || emptyEmailList
);

export const getNewsletterList = createSelector(getEmailLists, (lists) => {
    return lists.filter((x) => x.type === 'newsletter');
});

const getLoadTime = createSelector(sliceSelector, (state) => state.loaded || 0);

const isLoading = createSelector(sliceSelector, (state) => state.loading || false);

export const shouldFetchEmailLists = createSelector([getLoadTime, isLoading], (loaded, isAlreadyLoading) => {
    const time = Date.now();
    const diff = time - loaded;
    if (diff < EMAIL_LIST_CACHE_TIME) {
        return false;
    }
    return !isAlreadyLoading;
});
